import styled from '@emotion/styled';
import theme from '../../theme';
import Icon from '../../components/icon';
import { Typography } from '@mui/material';

export const DropZone = styled('div')`
  width: 100%;
  height: 100%;
  text-align: center;
  border: 1px solid transparent;
  background-color: #f9f9fb;
  border-radius: ${theme.shape.borderRadius}px;
  border: 1px solid ${theme.palette.border.secondary};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const DropZoneIcon = styled(Icon)`
  margin: 0 auto;
`;

export const DropZoneLabel = styled(Typography)`
  padding: 0 ${theme.spacing(4)};
  margin-top: ${theme.spacing(0.5)};
  font-weight: 600;
  color: ${theme.palette.text.primary};
  cursor: pointer;
`;

export const ErrorText = styled(Typography)`
  margin-top: ${theme.spacing(1)};
`;
